"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;

var _react = _interopRequireDefault(require("react"));

var _BaseTheme = _interopRequireDefault(require("../../Themes/BaseTheme"));

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

const Smile = () => /*#__PURE__*/_react.default.createElement("svg", {
  xmlns: "http://www.w3.org/2000/svg",
  viewBox: "-15 -5 100 75"
}, /*#__PURE__*/_react.default.createElement("defs", null, /*#__PURE__*/_react.default.createElement("filter", {
  id: "a"
}, /*#__PURE__*/_react.default.createElement("feColorMatrix", {
  in: "SourceGraphic",
  values: "0 0 0 0 0.435294 0 0 0 0 0.435294 0 0 0 0 0.435294 0 0 0 1.000000 0"
}))), /*#__PURE__*/_react.default.createElement("g", {
  transform: "translate(-6 -6)",
  fill: "none",
  fillRule: "evenodd"
}, /*#__PURE__*/_react.default.createElement("g", {
  fill: _BaseTheme.default.colors.gray,
  fillRule: "nonzero"
}, /*#__PURE__*/_react.default.createElement("path", {
  d: "M40 6.667c18.414 0 33.333 14.919 33.333 33.333 0 18.414-14.919 33.333-33.333 33.333C21.586 73.333 6.667 58.414 6.667 40 6.667 21.586 21.586 6.667 40 6.667zM27.876 49.382c-1.8-2.191-5.12.55-3.306 2.742a20.091 20.091 0 0030.86.013c1.815-2.19-1.478-4.933-3.306-2.755a15.793 15.793 0 01-24.248 0z",
  opacity: ".4"
}), /*#__PURE__*/_react.default.createElement("path", {
  d: "M58.817 35.457c-.537-3.387-4.597-5.659-8.05-5.659-3.455 0-7.514 2.272-8.052 5.659-.242 1.505 1.546 2.446 2.661 1.452l1.277-1.143c1.99-1.774 6.21-1.774 8.2 0l1.303 1.143c1.129 1.008 2.89.04 2.661-1.452zm-29.57-6.21a4.301 4.301 0 100 8.602 4.301 4.301 0 000-8.602z"
}))));

var _default = Smile;
exports.default = _default;